import useFlag, { FLAGS } from '@rover/shared/js/hooks/useFlag';

type UsePetInfoCalloutsExperimentReturn = {
  isActive: boolean;
};

/**
 * Hook to check if the pet_info_callouts experiment is active.
 * This experiment controls whether to show/hide certain pet preference filters
 * in the search experience.
 */
export const usePetInfoCalloutsExperiment = (): UsePetInfoCalloutsExperimentReturn => {
  const isActive = useFlag(FLAGS.ROLLOUT_PET_INFO_CALLOUT_EXPERIMENT);

  return { isActive };
};
